"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OpenMatchingDialogModule = /** @class */ (function () {
    function OpenMatchingDialogModule() {
    }
    return OpenMatchingDialogModule;
}());
exports.OpenMatchingDialogModule = OpenMatchingDialogModule;
